import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import ProdIOOOmrViewRow from './ProdIOOOmrViewRow'
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormLabel from '../../../../../library/form/components/FormLabel';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOOmrView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="SF Returns" /></span>
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Returned" /></li>
                                <FormWrapper formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                    action={{ paramName: "showCost" }} >
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Unit Cost (M)" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Labor Unit Cost (L)" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="OH Unit Cost (O)" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Total Unit Cost (M + L + O)" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Final Amount (Qty * Total Unit Cost)" /></li>
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "showAIC" }} >
                                    <SarasTrans value="Absorb Cost" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Transaction Type" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Transaction ID" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOOmrViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOOmrView, "prodIOOmr", "");
